module.exports = __webpack_public_path__ + "static/media/599.7554(9).594ffb72.pdf";